import {Injectable} from "@angular/core";
import {
  IssueType, MessageControlDto,
  MessageIssuePreviewDto,
  SubmitMessageIssueDto
} from "@server-models";
import {FormGroup} from "@angular/forms";
import {SharedIssueStereotypeBaseService} from "@shared/components/issues/services/stereotype/shared-issue-stereotype-base.service";
import {TCurrentIssueDto} from "../types/issue-dto.type";
import {ILocalIssueDetailData} from "@shared/components/issues/interfaces/local-issue-detail-data.interface";
import {IAdditionalDetails} from "@shared/components/issues/interfaces/additional-details.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueControlMessageService extends SharedIssueStereotypeBaseService {

  override formatReadDetailData(issueDtoType: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    const issueDtoTypeControlMessage = issueDtoType as MessageControlDto;
    return {
      ...this.formatBaseReadDetailData(issueDtoTypeControlMessage, issueType),
      additionalDetails: { ...this.getAdditionalFormattedData(issueDtoType) }
    };
  }

  prepareFormIssueDto(formGroup: FormGroup, templatePreviewDto: MessageIssuePreviewDto): SubmitMessageIssueDto {
    return {} as any;
  }

  getAdditionalFormattedData(issueDto: MessageControlDto): Partial<IAdditionalDetails> {
    return { controlMessage: issueDto };
  }

}
